import { QuoteFormSearchResponse, QuoteItemsSearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';
import { getEngine } from '@lio/rule-engine';

export type QuoteItem = ArrayItem<QuoteItemsSearchResponse['items']>;
export type QuoteItemAttribute = ArrayItem<QuoteItem['quoteItemAttributes']>;
export type QuoteItemAttributeValue = QuoteItemAttribute['value'];
export type QuoteItemAttributeProps = Pick<
  QuoteItemAttribute,
  'id' | 'quoteItemAttributeTypeId' | 'value' | 'valueOverride' | 'isUpdatedByUser' | 'isLocked'
>;
export type QuoteItemProps = Pick<QuoteItem, 'quoteItemTypeId' | 'instanceNumber' | 'id'> & {
  parentId: string | null | undefined;
  quoteItemAttributesById: QuoteItemAttributeStore;
};
export type QuoteItemStore = Record<string, QuoteItemProps>;
export type QuoteItemAttributeStore = Record<string, QuoteItemAttributeProps>;

export enum CodeName {
  AddressCity = 'AddressCity',
  AddressState = 'AddressState',
  AddressStreet = 'AddressStreet',
  AddressStreet2 = 'AddressStreet2',
  AddressZip = 'AddressZip',
  IsAddressApproved = 'IsAddressApproved',
  Jurisdiction = 'Jurisdiction',
  LocationName = 'LocationName',
  StateCode = 'StateCode',
  NamedInsured = 'NamedInsured',
  Policy = 'Policy',
  QuoteLocation = 'QuoteLocation',
  PropertyRisk = 'PropertyRisk',
}

export type ValidationError = ReturnType<ReturnType<typeof getEngine>['validateQuoteItem']>[number] & {
  listItemGroupIndex?: number | null;
};

export type QuoteFormItem = ArrayItem<QuoteFormSearchResponse['items']>;
export type QuoteFormAttribute = QuoteFormItem['quoteFormAttributes'][number];
